import { Action, History, Location, UnregisterCallback } from 'history'
import { Component, ReactNode } from 'react'

import { isPresent } from '../../utils/lang'

type RenderProp = (
  props: {
    showPrompt: boolean
    originalPathname: string
    onClose: () => void
    onConfirm: () => void
  }
) => ReactNode

type Props = {
  active: boolean
  history: History
  children: RenderProp
}

const initialState = {
  renderDialog: false,
  originalPathname: '',
}

type State = typeof initialState

export class FormPrompt extends Component<Props, State> {
  unblock = null as UnregisterCallback | null

  readonly state: State = initialState

  render() {
    const { active, children } = this.props
    const { renderDialog, originalPathname } = this.state

    return active
      ? children({
          showPrompt: renderDialog,
          originalPathname,
          onClose: this.handleClose,
          onConfirm: this.handleConfirm,
        })
      : null
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.active === this.props.active) {
      return
    }

    // unblock navigation if active change from true -> false
    if (prevProps.active && !this.props.active) {
      this.unregister()
    }

    if (this.props.active && !this.state.renderDialog) {
      this.registerHandler()
    }
  }

  componentDidMount() {
    if (this.props.active) {
      this.registerHandler()
    }
  }

  componentWillUnmount() {
    this.unregister()
  }

  registerHandler() {
    this.unblock = this.props.history.block((location: Location, action: Action) => {
      this.setState({ renderDialog: true, originalPathname: location.pathname })

      return false
    })
  }

  unregister = () => isPresent(this.unblock) && this.unblock()

  handleClose = () => this.setState({ renderDialog: false })
  handleConfirm = () => {
    this.unregister()
    this.handleClose()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/form-prompt/form-prompt.tsx